"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgCoffeeOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M2 25h28v2H2zM16 23c4.83 0 7.73-1.68 8.65-5h.82a4.5 4.5 0 000-9H7.05v6.45a7.17 7.17 0 001.88 5.31C10.43 22.26 12.74 23 16 23zm9.47-12a2.5 2.5 0 010 5H25v-5zM9.05 11H23v4.45c0 3.83-2.18 5.55-7 5.55-2.7 0-4.55-.54-5.65-1.65a5.19 5.19 0 01-1.3-3.89zM11.73 5c.88.22 1.24.31 1.24 2h2c0-3-1.36-3.62-2.75-4-.88-.19-1.22-.28-1.22-2H9c0 3 1.34 3.62 2.73 4zM18.73 5c.88.22 1.24.31 1.24 2h2c0-3-1.36-3.62-2.75-4-.88-.19-1.22-.28-1.22-2h-2c0 3 1.34 3.62 2.73 4z" })));
}
exports.default = SvgCoffeeOutline;
//# sourceMappingURL=CoffeeOutline.js.map